import React from "react";
import InformationModal from "./InformationModal";
import { numberWithSpaces } from "../services/utils/format";
import { strings } from "../assets/resources/translations"; //TODO: Refactor
import ToolTip from "./ToolTip";

export default (input) => (
  <div className="form-element">
    <form>
      <label className="input input-radio" tabIndex="0">
        <span
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className={`label ${input.bold && "bold-label"}`}>
            {input.label}
          </span>
          {input.link ? (
            <p style={{ "min-width": "100px", paddingTop: "5px" }}>
              <a href={input.link} target="_blank">
                {strings["readMore"]}
              </a>
            </p>
          ) : (
            ""
          )}
        </span>

        <div className="group">
          {
            input.options.length > 0 ? (
              input.options.map((o) => (
                <div className="radio-group" key={o.value}>
                  <label key={o.value}>
                    <input
                      type="radio"
                      name={input.name}
                      value={o.value}
                      checked={o.value === input.value ? true : false}
                      onChange={input.onChange}
                      disabled={input.disabled}
                    />

                    <i
                      class="svg-radio"
                      role="radio"
                      aria-label="Default radio"
                      aria-checked="false"
                    >
                      <svg
                        class="svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                      >
                        <circle class="fill" cx="12" cy="12" r="11" />
                        <circle class="stroke" cx="12" cy="12" r="11" />
                      </svg>
                    </i>
                    <span className="label-inline">
                      {strings[o.label] || o.labelText || strings[o.name] || o.label || o.name}
                    </span>
                    <div className="information-wrapper">
                      {o.information ? (
						<ToolTip icon="question-mark-circled" text={strings[o.information.text]}/>

                      ) : (
                        <span>&nbsp;</span>
                      )}
                    </div>
                    {o.price && o.price !== 0 ? (
                      <span className="label-price">
                        +{numberWithSpaces(o.price)}
                      </span>
                    ) : null}
                  </label>
                </div>
              ))
            ) : (
              <p>{input.placeholder}</p>
            ) // TODO
          }
        </div>
        <span className="input-message">
          <p className="message">
            {(input.value !== undefined || input.displayError) &&
              (input.error || input.message)}
          </p>
        </span>
      </label>
    </form>
  </div>
);
